import React from "react";

import linkedinIcon from '../../assets/icons/linkedin.png';
import twitterIcon from '../../assets/icons/twitter.png';
import facebookIcon from '../../assets/icons/facebook.png';
import instagramIcon from '../../assets/icons/instagram.png';
import './footer.styles.scss';

const Footer = () => {
  return (
    <div className='section' style={{backgroundColor: '#A6A6A6'}}>
      <div className="title center" style={{color: 'white'}}>Contacts</div>
      <hr style={{backgroundColor: 'white'}} />

      <div className='content'>
        <b>Phone: </b>(1)289-400-8771
        <br /><b>Email: </b><a href='mailto: k9yoon@uwaterloo.ca' className='email'>k9yoon@uwaterloo.ca</a>
        <br /><br />
        <div className='center'>
          <a target='_blank' rel="noopener noreferrer" href='https://www.linkedin.com/in/kwan-yoon/'>
            <img alt='linkedinIcon' src={linkedinIcon} className='footer-icon icon-animate' />
          </a>
          <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/KwanYoon_">
            <img alt="twitterIcon" src={twitterIcon} className='footer-icon icon-animate' />
          </a>

          <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=100009422362470">
            <img alt="facebookIcon" src={facebookIcon} className='footer-icon icon-animate' />
          </a>

          <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/kwan_y_n/?hl=ko">
            <img alt="instagramIcon" src={instagramIcon} className='footer-icon icon-animate' />
          </a>
        </div>
      </div>
      
      <hr className='wide' style={{backgroundColor: 'white'}} />
    </div>
  );
}

export default Footer;
